import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { STORAGE_KEY_INVITATION_ID } from '../constants/storage.constants';

@Injectable({
  providedIn: 'root',
})
export class InstitutionInvitationService {
  readonly #http = inject(HttpClient);

  /* eslint-disable class-methods-use-this -- localStorage-backed, no instance state */
  readonly getId = (): string | null =>
    localStorage.getItem(STORAGE_KEY_INVITATION_ID);

  readonly setId = (id: string): void => {
    localStorage.setItem(STORAGE_KEY_INVITATION_ID, id);
  };

  readonly clear = (): void => {
    localStorage.removeItem(STORAGE_KEY_INVITATION_ID);
  };
  /* eslint-enable class-methods-use-this */

  readonly fetchEmail = (id: string): Observable<{ email: string }> =>
    this.#http.get<{ email: string }>(`/api/institutions/invitations/${id}`);
}
